module.exports = __webpack_public_path__ + "img/leval-6.c3243dd7.png";